/*** IMPORTS FROM imports-loader ***/
var loadTerrific = require("bootstrap/load-terrific");
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function($, Module, w, SCS) {
	'use strict';
	/**
	 * Rating stars component
	 *
	 * @author Branislav Maksin
	 * @namespace Tc.Module
	 * @class RatingsStars
	 * @extends Tc.Module
	 */
	Module.RatingStars = Module.extend({

		/**
		 * Does all the work.
		 *
		 * @method on
		 * @param {Function} callback function
		 * @return void
		 */
		on: function(callback) {
			var mod = this;
			var $ctx = mod.$ctx;

			mod.$ratingStarsWrapper = $ctx.find('.rating-stars');
			mod.$flyOut = $ctx.find('> .flyOut');

			// Product JSON data
			mod.summaryData = null;

			this.sandbox.application.registry.EcommerceProductDataHub.module.simpleSubscribe(mod, mod.processData);

			callback();
		},

		after: function() {},

		/**
		 * Process products IDs and get products JSONs data
		 *
		 */
		processData: function processData(data) {
			var mod = this;

			if(mod.initialized){
				return;
			}

			var family = data.family;
			var ratings = family.getRatings();
			if(!ratings.loaded()) {
				// Register callback for when rating data is loaded
				ratings.load().done($.proxy(processData, mod, data));
				return;
			}

			mod.initialized = true;

			mod.family = family;

			if(!family) {
				mod.log('Module doesn’t have any IDs');
				mod.$ctx.removeClass('scs-loadingRotator').addClass('error');
				return;
			}

			if(mod.$ctx.hasClass('error')){
				mod.$ctx.removeClass('error').addClass('scs-loadingRotator');
			}

			var summary = ratings.getSummary();

			mod.showRatingSummary(summary);

			mod.$ctx.removeClass('scs-loadingRotator');

		},

		/**
		 * Insert the summary data into DOM elements
		 *
		 * @param summaryData {Object} Final summary data
		 */
		showRatingSummary: function(summaryData) {
			var mod = this,
				$ctx = mod.$ctx;

			var $flyOut = mod.$flyOut;

			var count = summaryData.count();
			var rating = summaryData.getAverage(true);

			// Set the rating star summary
			var $ratingStars = mod.$ratingStarsWrapper.find('> span');
			$ratingStars.addClass('empty').filter(':lt(' + rating + ')').removeClass('empty');
			$ratingStars.filter(':last-child').text('(' + (count || 0) + ')');

			if(!count) {
				mod.log('no ratings yet!');
				return;
			}

			// Check if we are on product detail page
			if ($ctx.hasClass('rating-details')) {
				mod.addClickEvent();

				if ($flyOut.length) {
					// Set fly out ratings
					$flyOut.find('> ul').each(function() {
						var $flyOutRatings = $(this).find('> li');
						var $link = $flyOutRatings.find('a');
						var stars = $link.data('stars');
						var starCount = summaryData.count(stars);
						$flyOutRatings.find('> span').width(((starCount / count) * 100) + '%');
						$flyOutRatings.filter(':last-child').text('(' + starCount + ')');
						if(!starCount){
							$link.addClass('disabled');
						}
					});

					mod.addFlyOut(mod.$ratingStarsWrapper, $flyOut);
				}
			}
		},

		/**
		 * Add fly out tooltip on mouse over event
		 *
		 * @param $ratingStars {Object} Rating star element
		 * @param $flyOut {Object} Fly out element
		 */
		addFlyOut: function ($ratingStars, $flyOut) {
			var mod = this,
				flyOutPosition = {};

			// Select proper position
			switch (mod.$ctx.data('flyout-position')) {
				case 'top':
					flyOutPosition.my = 'bottom center';
					flyOutPosition.at = 'top center';
					flyOutPosition.adjustY = 16;
					flyOutPosition.adjustX = 0;
					break;

				case 'right':
					flyOutPosition.my = 'left center';
					flyOutPosition.at = 'right center';
					flyOutPosition.adjustY = 0;
					flyOutPosition.adjustX = 5;
					break;

				case 'left':
					flyOutPosition.my = 'right center';
					flyOutPosition.at = 'left center';
					flyOutPosition.adjustY = 0;
					flyOutPosition.adjustX = -5;
					break;

				default:
					flyOutPosition.my = 'top center';
					flyOutPosition.at = 'bottom center';
					flyOutPosition.adjustY = -18;
					flyOutPosition.adjustX = 0;
			}

			// Start qtip2 plugin
			$ratingStars.qtip({
				position: {
					my: flyOutPosition.my,
					at: flyOutPosition.at,
					viewport: $(window),
					target: $ratingStars,
					adjust: {
						scroll: false,
						y: flyOutPosition.adjustY,
						x: flyOutPosition.adjustX,
						method: 'none flipinvert'
					},
					effect: function(api, pos) {
						$(this).animate(pos, {
							duration: 250,
							easing: 'linear',
							queue: false
						});
					}
				},
				content: {
					text: $flyOut
				},
				hide: {
					fixed: true,
					delay: 400
				},
				style: {
					classes: 'modRatingStars',
					tip: {
						width: 16,
						border: 2
					}
				}
			});
		},

		/**
		 * Add click event to open rating and review tab
		 *
		 * @param $ratingStars {Object} Rating summary element
		 */
		addClickEvent: function () {
			var mod = this,
				$ctx = mod.$ctx,
				tabNavigationName = $ctx.data('navigation-name'),
				$tabNavigation = $('.modTabNavigation[data-name="' + tabNavigationName + '"], .modSDXTabs'),
				tabNavigationOrder = parseInt($ctx.data('rating-tab')),
				$tabNavigationContent,
				$tabNavigationTab;

			// Check if tab bar exists
			if(!$tabNavigation.length) {
				return;
			}

			$tabNavigationTab = $tabNavigation.find('.tab-navigation-tab:nth-child(' + tabNavigationOrder + '), [data-panel="ratings"]');
			$tabNavigationContent = $tabNavigation.find('.modTabNavigationContent:nth-child(' + tabNavigationOrder + ')');
			if ($tabNavigationContent.length === 0) {
				$tabNavigationContent = $('.section .ratings');
			}

			// Add click event to open and scroll to review tab content
			if(!$tabNavigationTab.length) {
				return;
			}

			mod.$ratingStarsWrapper.addClass('click');
			mod.$ratingStarsWrapper.on('click', function(e) {
				e.preventDefault();

				var currentScrollTop = $('body').scrollTop();

				$('.content-reset-button:visible:eq(0)').trigger('click');
				$tabNavigationTab.trigger('click');

				if (!SCS.utils.isMobilePage()){
					// Scroll to ratings tab content
					$('html, body').animate({
						scrollTop: $tabNavigationContent.offset().top
					}, 800);
				} else {
					$('html, body').scrollTop(currentScrollTop);
				}

				// Tracking
				mod.addTracking();
			});
			mod.$flyOut.on('click', '.label a', function(event) {
				event.preventDefault();

				var $link = $(this);
				if($link.is('.disabled')) {
					// Do nothing
					return;
				}
				var stars = $link.data('stars');

				mod.$ratingStarsWrapper.qtip('toggle', false);
				mod.$ratingStarsWrapper.trigger('click');

				SCS.HashDeepLink.set('rating-list-stars', stars, '&');
				mod.fire('setRatingListFilter', {}, ['rarev']);
			});
		},
		/**
		 * Track the fly out opening event
		 */
		addTracking: function () {

			// jshint camelcase: false
			var mod = this;
			mod.trackingTealium();
		},

		/**
		 * Tealium tracking
		 */
		trackingTealium: function () {
			// jshint camelcase: false
			SCS.portal.datalayer.trackEvent('click', 'r_ratingstars', 'content', 'Rating');
		}
	});
})(window.Tc.$, window.Tc.Module, window, window.SCS);

}.call(window));


//////////////////
// WEBPACK FOOTER
// ./clientlibs/js/etc/designs/portal/clientlibs/shared/js/modules/Tc.Module.RatingStars.js
// module id = 175
// module chunks = 0